import React, { Component } from "react";
import "./SignaturePanel.component.css";
import DropDownSelect from "../../common/form-fields/drop-down/DropDownSelect";
import Helpers from "../../common/util/Helpers";

class SignaturePanel extends Component {

    constructor(props) {
        super(props);

        this.state = {
            activePanel: "front"
        }
    }

    customizePlan() {
        this.setState({
            activePanel: "back"
        });
    }

    viewFront() {
        this.setState({
            activePanel: "front"
        });
    }

    renderCoinsurance() {
        let coinsuranceOptions = [];
        this.props.policyDetails.policies.map(policy => {
            
                if (!coinsuranceOptions.find(ele => ele.value === policy.reimbursement * 100)) {
                    let obj = { displayName: policy.reimbursement * 100 + "%", value: policy.reimbursement * 100 }
                    coinsuranceOptions.push(obj);
                }
          
        });

        coinsuranceOptions.sort((op1, op2) => {
            if (op1.value > op2.value) return 1;
            return -1;
        })

        if (coinsuranceOptions.length >=2) {

        return (
            <DropDownSelect
                style={{ width: "100%", backgroundColor: "#FFF" }}
                field="coinsurance"
                className="custom-dropdown"
                id="signature_coinsurance"
                data={coinsuranceOptions}
                onChange={this.props.handleCoinsuranceChange.bind(this)}
                initialValue={this.props.tempSelectedCoinsurance}
            />
        )
        } else if (coinsuranceOptions.length === 1) {
            return (
                <div className="text-left single-reimbursement-text">
                    <p class="customize-single-value">{coinsuranceOptions[0].displayName}</p>
                </div>
            )
        } else {
            return (
                <div className="text-left">
                    No coinsurance options available
                </div>
            )
        }
    }

    renderDeductible() {
        let deductibleOptions = [];
        const selectedCoinsurance = Number(this.props.tempSelectedCoinsurance);

        if (!selectedCoinsurance) return null;

        // Get all policies matching selected reimbursement
        const matchingPolicies = this.props.policyDetails.policies.filter(
            policy => policy.reimbursement * 100 === selectedCoinsurance
        );

        // Check if BOTH plan types exist for this reimbursement
        const hasSignature = matchingPolicies.some(p => p.deductible < 1500);
        const hasHighDeductible = matchingPolicies.some(p => p.deductible >= 1500);

        matchingPolicies.forEach(policy => {

            // CASE 1: If reimbursement exists in BOTH → show ALL deductibles
            if (hasSignature && hasHighDeductible) {
                if (!deductibleOptions.find(ele => ele.value === policy.deductible)) {
                    deductibleOptions.push({
                        displayName: "$" + policy.deductible,
                        value: policy.deductible
                    });
                }
            }

            // CASE 2: Only Signature available
            else if (hasSignature && policy.deductible < 1500) {
                if (!deductibleOptions.find(ele => ele.value === policy.deductible)) {
                    deductibleOptions.push({
                        displayName: "$" + policy.deductible,
                        value: policy.deductible
                    });
                }
            }

            // CASE 3: Only High Deductible available
            else if (hasHighDeductible && policy.deductible >= 1500) {
                if (!deductibleOptions.find(ele => ele.value === policy.deductible)) {
                    deductibleOptions.push({
                        displayName: "$" + policy.deductible,
                        value: policy.deductible
                    });
                }
            }

        });

        // Sort values
        deductibleOptions.sort((a, b) => a.value - b.value);

        const isValid = deductibleOptions.some(
            op => op.value === this.props.tempSelectedDeductible
        );

        const safeValue = isValid
            ? this.props.tempSelectedDeductible
            : deductibleOptions[0]?.value;

        return (
            <DropDownSelect
                style={{ width: "100%", backgroundColor: "#FFF" }}
                field="deductible"
                className="custom-dropdown"
                id="signature_deductible"
                data={deductibleOptions}
                onChange={this.props.handleDeductibleChange.bind(this)}
                initialValue={safeValue}
            />
        );
    }

    renderAnnualLimit() {
        let annualLimitOptions = [];

        const pet = this.props.policyDetails.pet;

        const remainingAnnulLimit = pet.remaining_Annual_Limit;
        const claimCounts = pet.claim_Count;
        const petPolicyChangeStatus = pet.policy_Limit_Change_Status;
        const petEffectiveDate = pet.pet_Effective_Date;

        this.props.policyDetails.policies.forEach(policy => {
            if (!annualLimitOptions.find(ele => ele.value === policy.annual_limit)) {
                const annualLimitDisplay =
                    policy.annual_limit?.toString().toLowerCase().includes("unlimited")
                        ? policy.annual_limit.replace(/\$/g, "").trim()
                        : `$${policy.annual_limit}`;

                annualLimitOptions.push({
                    displayName: annualLimitDisplay,
                    value: policy.annual_limit
                });
            }
        });

        annualLimitOptions.sort((op1, op2) => {
            if (op1.value > op2.value) return 1;
            return -1;
        });

        const renderSingleAnnualLimitValue = () => {
            const selectedPolicyLimit = this.props.tempSelectedPolicyLimit;

            const selectedPolicyLimitDisplay =
                selectedPolicyLimit?.toString().toLowerCase() === "unlimited"
                    ? "Unlimited"
                    : `$${selectedPolicyLimit}`;

            return (
                <div className="text-left single-reimbursement-text">
                    <p className="customize-single-value">
                        {selectedPolicyLimitDisplay}
                    </p>
                </div>
            );
        };

        const isPetEffectiveDateWithinOneYear = () => {
            if (!petEffectiveDate) {
                return false;
            }

            const effectiveDate = new Date(petEffectiveDate);

            if (isNaN(effectiveDate.getTime())) {
                return false;
            }

            const today = new Date();

            const oneYearFromEffectiveDate = new Date(effectiveDate);
            oneYearFromEffectiveDate.setFullYear(oneYearFromEffectiveDate.getFullYear() + 1);

            // Pet Effective Date should be within the current 1-year policy frame.
            return today < oneYearFromEffectiveDate;
        };

        const isPolicyLimitChangeAllowed = () => {
            // Use Case 1:
            // No policy limit change has been made yet.
            if (!petPolicyChangeStatus) {
                return true;
            }

            // Use Case 2:
            // Status is Pending.
            else if (petPolicyChangeStatus?.toLowerCase() === "pending") {
                return true;
            }

            // Use Case 3:
            // Status is applied.
            else if (petPolicyChangeStatus?.toLowerCase() === "applied") {
                return false;
            }
        };

        // Validation 1:
        // Remaining Annual Limit should be available
        // and Pet Effective Date should be within 1 policy year.
        const isRemainingLimitAvailable = ((remainingAnnulLimit === 0.0 || remainingAnnulLimit === 0) && isPetEffectiveDateWithinOneYear());

        // Validation 3:
        // Policy Limit Change Date and Status validation.
        const isPolicyLimitAllowed =
            isPolicyLimitChangeAllowed();

        const hasMultipleAnnualLimitOptions =
            annualLimitOptions.length >= 2;

        const hasSingleAnnualLimitOption =
            annualLimitOptions.length === 1;

        if (
            hasMultipleAnnualLimitOptions &&
            isPolicyLimitAllowed && (!isRemainingLimitAvailable)
        ) {
            return (
                <DropDownSelect
                    style={{ width: "100%", backgroundColor: "#FFF" }}
                    field="policyLimit"
                    className="custom-dropdown"
                    id="signature_AnnualPolicyLimit"
                    data={annualLimitOptions}
                    onChange={this.props.handlePolicyLimitChange.bind(this)}
                    initialValue={this.props.tempSelectedPolicyLimit}
                />
            );
        }
        else if (isRemainingLimitAvailable) {
            return renderSingleAnnualLimitValue();
        }
        else if (!isPolicyLimitAllowed) {
            return renderSingleAnnualLimitValue();
        }
        else if (hasSingleAnnualLimitOption) {
            return (
                <div className="text-left single-reimbursement-text">
                    <p className="customize-single-value">
                        {annualLimitOptions[0].displayName}
                    </p>
                </div>
            );
        }
        else {
            return (
                <div className="text-center">
                    No Maximum Annual Payout options available
                </div>
            );
        }
    }

    selectPlanType() {
        this.props.setSelectedPlanType("signature");
        this.viewFront();
    }

    render() {
      return (
    <div className="signature-panel mb-4">

        { this.state.activePanel === "front" && 
        <div id="signaturePanelFront">

            <article className={`plan-card ${this.props.selectedPlanType === "signature" ? "selected" : ""}`} aria-label="Signature Insurance Plan">

                {/* LEFT SECTION */}
                <div className="plan-left">

                    <div className="plan-heading">
                                  <span className="check-icon" aria-hidden="true">
                                  </span>
                        {/*<span className="plan-icon" aria-hidden="true">*/}
                        {/*    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">*/}
                        {/*        <path*/}
                        {/*            d="M20 6L9 17L4 12"*/}
                        {/*            stroke="white"*/}
                        {/*            strokeWidth="3"*/}
                        {/*            strokeLinecap="round"*/}
                        {/*            strokeLinejoin="round"*/}
                        {/*        />*/}
                        {/*    </svg>*/}
                        {/*</span>*/}

                        <h2 className="plan-title">Signature Plan</h2>

                    </div>

                    <p className="plan-subtitle">
                        Comprehensive, customizable coverage
                        <br />
                        for accidents & illness
                    </p>

                    <p className="plan-description">
                        Coverage for accidents and illnesses,
                        designed for life's daily adventures
                        and the surprises you can't foresee.
                    </p>

                </div>

                {/* RIGHT SECTION */}
                <div className="plan-right">

                    <div className="plan-price">
                        <span className="price">
                            {Helpers.formatCurrency(this.props.selectedPremium)}
                        </span>
                        <span className="per-month">/mo.</span>
                    </div>

                    <div className="plan-info">

                        <div className="plan-row">
                            <span className="text-normal">Maximum Annual Payout</span>
                                      <span className="text-bold">
                                          {
                                              this.props.selectedAnnualLimit?.toString().toLowerCase().includes('unlimited')
                                                  ? this.props.selectedAnnualLimit.replace(/\$/g, '').trim()
                                                  : `$${this.props.selectedAnnualLimit}`
                                          }
                                          </span>
                        </div>

                        <div className="plan-row">
                            <span className="text-normal">Reimbursement</span>
                            <span className="text-bold">{this.props.selectedCoinsurance}%</span>
                        </div>

                        <div className="plan-row">
                            <span className="text-normal">Annual Deductible</span>
                            <span className="text-bold">${this.props.selectedDeductible}</span>
                        </div>

                    </div>

                    <button
                        onClick={this.customizePlan.bind(this)}
                        className="plan-button"
                    >
                        Customize Plan
                    </button>

                    {/* { this.props.selectedPlanType === "signature" ? 
                        (
                            <button type="button" className="button-primary button-plan-selected">
                                Selected
                                <img src="/assets/images/check-mark-white.png" className="ml-1 check-mark-white" />
                            </button>
                        ) :
                        (
                            <div
                                onClick={this.selectPlanType.bind(this)}
                                className="whiteBtn"
                            >
                                Select This Plan
                            </div>
                        )
                    } */}

                </div>

            </article>

        </div> }

        { this.state.activePanel === "back" && 
        <div id="signaturePanelBack">

            <div className="plan-container">

                <div className="plan-header">
                    <div>
                        <h2 className="plan-title">Customize the Signature Plan</h2>
                        <p>Available options may change based off your chosen ranges.</p>
                    </div>

                    <span className="close-btn" onClick={this.viewFront.bind(this)}>✕</span>
                </div>

                <div className="plan-grid">

                    <div className="form-group">
                        <label>Maximum Annual Payout</label>
                         {this.renderAnnualLimit() }
                    </div>

                    <div className="form-group">
                        <label>Reimbursement</label>
                        {this.renderCoinsurance()}
                    </div>

                      <div className="form-group margin-bottom-override">
                        <label>Annual Deductible</label>
                        {this.renderDeductible()}
                              </div>
                              <div className="form-group">
                                  <div className="plan-footer">
                                  <div className="price">
                                      {Helpers.formatCurrency(this.props.tempSelectedPremium)}
                                      <span>/mo.</span>
                                      
                                      </div>
                                      <button
                                          className="save-btn"
                                          onClick={this.selectPlanType.bind(this)}
                                      >
                                          Save
                                      </button>
                              </div>
                </div>

                </div>

            </div>

        </div> }

    </div>
)
    }
}



export default SignaturePanel;